import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const CalendarIcon = createSvgIcon(
  <>
    <path
      d="M1 5.66671C1 5.04787 1.24583 4.45438 1.68342 4.01679C2.121 3.57921 2.71449 3.33337 3.33333 3.33337H17.3333C17.9522 3.33337 18.5457 3.57921 18.9832 4.01679C19.4208 4.45438 19.6667 5.04787 19.6667 5.66671V19.6667C19.6667 20.2855 19.4208 20.879 18.9832 21.3166C18.5457 21.7542 17.9522 22 17.3333 22H3.33333C2.71449 22 2.121 21.7542 1.68342 21.3166C1.24583 20.879 1 20.2855 1 19.6667V5.66671Z"
      {...strokeProps}
    />
    <path d="M15 1V5.66667" {...strokeProps} />
    <path d="M5.66675 1V5.66667" {...strokeProps} />
    <path d="M1 10.3334H19.6667" {...strokeProps} />
    <path d="M5.66675 15H8.00008V17.3333H5.66675V15Z" {...strokeProps} />
  </>,
  { displayName: 'CalendarIcon', viewBox: '0 0 21 23' }
);
